'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThumbDown, iconThumbDownTag } from '@ni/nimble-components/dist/esm/icons/thumb-down';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThumbDown };
export { iconThumbDownTag };
export const NimbleIconThumbDown = wrap(IconThumbDown);